import { map, prop, fromPairs } from 'ramda';

const createInitialValues = <T>(qs: Record<'id', number>[], value: T): { [id: string]: T } => {
  const ids = map(prop<'id', number>('id'), qs);
  const pairs = map<number, [number, T]>((id) => [id, value], ids);
  return fromPairs(pairs);
};

export { createInitialValues };
